import { I18n } from 'i18n-js';
import translations from './translations.json';

// Create new I18n instance with Rails-exported translations (v4.x syntax)
const i18n = new I18n(translations);
i18n.defaultLocale = 'en';
i18n.locale = 'en';

// Export the configured I18n instance
export default i18n;
